import { executeRequest, Request } from '@jfs/network'
import { setPwdOnIDAMRequestBody } from '../data/request/requestbody'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const setPasswordOnIDAMReq = (mobile: string, password: string, otp: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.setPasswordOnIDAM,
    method: 'POST',
    config: sitConfig(tokens),
    body: setPwdOnIDAMRequestBody(mobile, password, otp),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { setPasswordOnIDAMReq }
